<template>
  <v-card class="modal-search-purpose-of-uses">
    <div class="px-[10px]" ref="modalScrollArea">
      <div class="modal-content">
        <div class="overflow-y-auto" style="margin-bottom: 50px">
          <div class="modal-header">
            <v-card-title>
              <div class="modal_header_text">
                <h1>エリアから探す</h1>
              </div>
            </v-card-title>
            <button @click="closeModal" type="button" class="btn-close_popup">
              <i class="fa-solid fa-xmark" style="color: #2892d7"></i>
            </button>
          </div>
          <div class="card-text">
            <div class="accordion-container" v-if="selectedAreaSummary.length != 0">
              <div class="modal-header">
                <h3>
                  適用中のエリア &nbsp;<a href="javascript:void(0)" @click="clearAreaSelection">クリア</a>
                </h3>
                <div class="header_text_block">
                  <Span v-for="(item, index) in selectedAreaSummary" :key="index">{{item.name}}</Span>
                </div>
              </div>
            </div>
            <div class="accordion-container">
              <div>
                <div class="search-section">
                    <img :src="search" alt="search-img">
                    <input type="text" placeholder="エリア名を入力すると候補から選択できます"  v-model="searchText" @input="handleInput" @focus="handleFocus"  :readonly="isMobile">
                    <i class="fa-solid fa-xmark" :class="{ active: searchText }" @click="removeSearch()"></i>
                </div>
                <div v-if="searchText">
                    <div class="search-suggest-data" v-if="matchedChildren.length > 0">
                        <ul>
                            <li v-for="child in matchedChildren" :key="child.id"  @click.stop="selectChild(child.id)" class="cursor-pointer">
                                <img :src="selectedItems.includes(child.id) ? RightIconActive : RightIcon" alt="right-icon">
                                {{ child.name }}
                            </li>
                        </ul>
                    </div>
                    <div class="search-suggest-data" v-else>
                        <ul>
                            <li style="border-bottom: none !important;">
                                候補が見つかりませんでした。
                            </li>
                        </ul>
                    </div>
                </div>
              </div>
                <p class="search-content-section">※ エリア名を入力すると候補が表示されます。候補をクリックすると選択（✓）されます。</p>
            </div>
            <div class="accordion-container">
                <div class="main-data-accordion-container">
                    <div class="accordion-section" v-for="(item, parentIndex) in props.allListArea" :key="item.id || parentIndex">
                        <div class="accordion-header">
                            <button class="min-w-[67px]" :class="{ active: isAllSelected(item) }" @click.stop="selectAllChild(item,parentIndex)">すべて</button>
                            <div class="accordian_Text" @click="toggleAccordion(parentIndex)">
                                <h3>{{item.name}}</h3>
                                <span class="self-center"><i class="fa-solid fa-angle-down" :class="{ 'rotate-180': isOpen(parentIndex) }"></i></span>
                            </div>
                        </div>
                        <div class="accordion-content" v-show="isOpen(parentIndex)">
                            <div class="accordianCustomeCheckBox_Detail" v-for="(childItem, index) in item.child" :key="index">
                                <label class="custom-checkbox">
                                <input type="checkbox" :value="childItem.id" v-model="selectedItems"/>
                                <span class="checkmark"></span>
                                   {{ childItem.name}} ({{ childItem.rental_space_publish }})
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="modal_bottom_contant">
          <a href="javascript:void(0)" @click="clearAreaSelection">クリア</a>
          <button @click="applyConditions">条件を適用する</button>
        </div>
      </div>
    </div>
  </v-card>
  <v-dialog v-model="isShowSearchModal" :class="['area-search-modal']">
    <ModalSearch
      @handleCloseSearchModal="handleCloseSearchModal"
      :allListArea="props.allListArea"
      :selectedItems="selectedItems"
      @selectAreaChild="selectChild"
    />
  </v-dialog>
</template>

<script setup>
/* eslint-disable */
import { defineEmits, ref, onMounted, onUnmounted } from "vue";
// import "@/client/components/SearchComponent/ModalSearchArea.scss";
import search from "@/client/assets/images/new-search.svg";
import { string } from "yup";
import ModalSearch from "./ModalSearch.vue";
import RightIcon from "@/client/assets/images/right-icon.svg";
import RightIconActive from "@/client/assets/images/right-icon-active.svg";
import { orderBy } from "lodash";

// Emit event for closing modal
const emit = defineEmits(["handleCloseAreaModal"]);
const closeModal = () => {
  emit("handleCloseAreaModal");
};

const handleFocus = () => {
  if (window.innerWidth <= 575) { // adjust breakpoint as needed
    showSearchModal();
  }
};
const isMobile = ref(window.innerWidth <= 575);
function updateIsMobile() {
  isMobile.value = window.innerWidth <= 575;
}

onMounted(() => {
  window.addEventListener('resize', updateIsMobile);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateIsMobile);
});
const props = defineProps({
  dataPopupArea:{
    type: Array,
    required: true,
  },
  allListArea: {
    type: Array,
    required: true,
  },
  selectedEmptyParents: {
    type: Array,
    required: true,
  },
});
const searchText = ref("");
const matchedChildren = ref([]);

const hiraganaTable = {
    'あ': ['あ', 'い', 'う', 'え', 'お'],
    'か': ['か', 'き', 'く', 'け', 'こ', 'きゃ', 'きゅ', 'きょ', 'が', 'ぎ', 'ぐ', 'げ', 'ご','ぎゃ','ぎゅ','ぎょ'],
    'さ': ['さ', 'し', 'す', 'せ', 'そ', 'しゃ', 'しゅ', 'しょ', 'ざ', 'じ', 'ず', 'ぜ', 'ぞ','じゃ','じゅ','じょ'],
    'た': ['た', 'ち', 'つ', 'て', 'と', 'ちゃ', 'ちゅ', 'ちょ', 'だ', 'ぢ', 'づ', 'で', 'ど'],
    'な': ['な', 'に', 'ぬ', 'ね', 'の', 'にゃ', 'にゅ', 'にょ'],
    'は': ['は', 'ひ', 'ふ', 'へ', 'ほ', 'ひゃ', 'ひゅ', 'ひょ', 'ば', 'び', 'ぶ', 'べ', 'ぼ', 'ぱ', 'ぴ', 'ぷ', 'ぺ', 'ぽ','びゃ','びょ','びゅ','ぴゃ','ぴゅ','ぴょ'],
    'ま': ['ま', 'み', 'む', 'め', 'も', 'みゃ', 'みゅ', 'みょ'],
    'や': ['や', 'ゆ', 'よ'],
    'ら': ['ら', 'り', 'る', 'れ', 'ろ', 'りゃ', 'りゅ', 'りょ'],
    'わ': ['わ', 'を']
};

function convertKanjiToFirstChar(kanji) {
  let firstChar = '';
  if(kanji){
      for (const key in hiraganaTable) {
      if (hiraganaTable[key].includes(kanji.charAt(0))) {
        firstChar = key;
        break;
      }
    }
  }
  if(firstChar == ''){
    firstChar = 'その他'
  }else{
    firstChar+='行'
  }
  return firstChar;
}

const handleInput = () => {
  const value = searchText.value.trim();

  if (!value) {
    matchedChildren.value = [];
    return;
  }

  matchedChildren.value = [];

  props.allListArea.forEach((item) => {

    const children = Array.isArray(item.child)? item.child : item.child && typeof item.child === 'object' ? Object.values(item.child): [];
    children.forEach((childItem) => {
      if (childItem.name.includes(value)) {
        matchedChildren.value.push({
          id: childItem.id,
          name: childItem.name,
          name_reading: childItem.name_reading,
        });
      }
    });
  });

    const groups = {};
    for (const key in hiraganaTable) {
        let groupKey = key + '行';
        groups[groupKey] = {
        letter: groupKey,
        active: true,
        areas: []
        };
    }
    groups['その他'] = {
        letter: 'その他',
        active: true,
        areas: []
    };

    matchedChildren.value.forEach(item => {
        item.name_reading = item.name_reading || '';
        const firstChar = convertKanjiToFirstChar(item.name_reading);
        (groups[firstChar] || groups['その他']).areas.push(item);
    });

    matchedChildren.value = Object.values(groups).flatMap(group => orderBy(group.areas, 'name_reading'));
};
const removeSearch = () => {
    searchText.value = "";
    matchedChildren.value = [];
}

const openIndexes = ref([]);

const toggleAccordion = (index) => {
  if (openIndexes.value.includes(index)) {
    openIndexes.value = openIndexes.value.filter((i) => i !== index);
  } else {
    openIndexes.value.push(index);
  }
};

const isOpen = (index) => openIndexes.value.includes(index);

const selectedEmptyParents = ref([]);
const selectedItems = ref([]);
// Select/deselect all children of a parent
const selectAllChild = (parentItem ,parentIndex) => {
  // Normalize child: if it's already an array, use it. If it's an object, convert to array of values.
  const children = Array.isArray(parentItem.child)
    ? parentItem.child
    : typeof parentItem.child == 'object' && parentItem.child != null
      ? Object.values(parentItem.child)
      : [];

  const childIds = children.map((child) => child.id);
  const allSelected = childIds.every((id) => selectedItems.value.includes(id));

  // Open the accordion if it's not open
  if (!isOpen(parentIndex)) {
    openIndexes.value.push(parentIndex);
  }
  
  if (children.length === 0) {
    if (selectedEmptyParents.value.includes(parentItem.id)) {
      selectedEmptyParents.value = selectedEmptyParents.value.filter(id => id !== parentItem.id);
    } else {
      selectedEmptyParents.value.push(parentItem.id);
    }
    return;
  }
  
  if (allSelected) {
    selectedItems.value = selectedItems.value.filter(
      (id) => !childIds.includes(id)
    );
  } else {
    selectedItems.value = [
      ...new Set([...selectedItems.value, ...childIds]),
    ];
  }
};

const selectChild = (id) => {
  // Find parent index safely
  const parentIndex = props.allListArea.findIndex(item =>
    Array.isArray(item.child) && item.child.some(child => child.id == id) || typeof item.child === 'object' && item.child !== null && Object.values(item.child).some(child => child.id == id)
  );
  // Open the parent accordion if it's not already open
  if (!openIndexes.value.includes(parentIndex) && parentIndex != -1) {
    openIndexes.value.push(parentIndex);
  }
  // Toggle selection
  if (selectedItems.value.includes(id)) {
    selectedItems.value = selectedItems.value.filter(item => item != id);
  } else {
    selectedItems.value.push(id);
  }
};

const isAllSelected = (parentItem) => {
  const children = Array.isArray(parentItem.child)
    ? parentItem.child
    : typeof parentItem.child === 'object' && parentItem.child !== null
      ? Object.values(parentItem.child)
      : [];

  if (children.length == 0) {
    return selectedEmptyParents.value.includes(parentItem.id);
  }
  const childIds = children.map(child => child.id);
  return childIds.every(id => selectedItems.value.includes(id));
};

const selectedAreaSummary= ref([]);

const applyConditions = () => {
  const selectedDetails = [];
  const SelectedParentIds = [];

  props.allListArea.forEach(parent => {
    const children = Array.isArray(parent.child)
      ? parent.child
      : typeof parent.child === 'object' && parent.child !== null
        ? Object.values(parent.child)
        : [];

    let allChildrenSelected = true;

    children.forEach(child => {
      if (selectedItems.value.includes(child.id)) {
        selectedDetails.push({
          id: child.id,
          name: child.name,
        });
      } else {
        allChildrenSelected = false;
      }
    });

    // If all children are selected and the parent has at least one child
    if (allChildrenSelected && children.length > 0) {
        SelectedParentIds.push(parent.id);
    }
  });

//   selectedAreaSummary.value = selectedDetails;
  emit('applyAreaConditions', {
    selectedAreaSummary: selectedDetails,
    SelectedParentIds, // emit the parent IDs with all children selected
    selectedEmptyParents: selectedEmptyParents.value,
  });

  closeModal();
};


const clearAreaSelection = () => {
  selectedItems.value = [];
  selectedAreaSummary.value = [];
  selectedEmptyParents.value = [];
  emit('applyAreaConditions', { selectedAreaSummary: selectedAreaSummary.value });
  closeModal();
};

onMounted(() => {
    if(props.selectedEmptyParents){
      selectedEmptyParents.value = props.selectedEmptyParents;
    }

  if (props.dataPopupArea && props.dataPopupArea.id) {
    const ids = props.dataPopupArea.id
      .split(',')
      .map(id => id.trim())
      .filter(id => id);

      ids.forEach(id => {
        const cleanId = parseInt(id); // ensure id is a string

        const parentIndex = props.allListArea.findIndex(item =>
            item.area_ids.includes(cleanId)
        );

        if (parentIndex != -1 && !openIndexes.value.includes(parentIndex)) {
            openIndexes.value.push(parentIndex);
        }

        if (selectedItems.value.includes(cleanId)) {
            selectedItems.value = selectedItems.value.filter(item => item != cleanId);
        } else {
            selectedItems.value.push(cleanId);
        }
     });
     
     const selectedDetails = [];
    const SelectedParentIds = [];

    props.allListArea.forEach(parent => {
        const children = Array.isArray(parent.child)
        ? parent.child
        : typeof parent.child == 'object' && parent.child != null
            ? Object.values(parent.child)
            : [];

      let allChildrenSelected = true;

      children.forEach(child => {
        if (selectedItems.value.includes(child.id)) {
          selectedDetails.push({
            id: child.id,
            name: child.name,
          });
        } else {
          allChildrenSelected = false;
        }
      });

      if (allChildrenSelected && children.length > 0) {
        SelectedParentIds.push(parent.id);
      }
    });

    selectedAreaSummary.value = selectedDetails;
  }
});


const isShowSearchModal = ref(false);
const showSearchModal = () => {
  isShowSearchModal.value = true;
};
const handleCloseSearchModal = () => {
    isShowSearchModal.value = false;
};

</script>

<style scoped lang="scss">

@import "./ModalSearchArea.scss";
</style>
